import { RESET_SEARCH, SearchActionTypes } from "../search/types";
import {
  FETCH_PORTFOLIOS_SUCCESS,
  PortfoliosActionTypes,
  PortfoliosState,
  FetchPortfoliosResponse,
  DELETE_EXCLUDE_PORTFOLIO_LIST_SUCCESS,
  DELETE_EXCLUDE_PORTFOLIO_LIST_REQUEST,
  RESET_EXCULDE_PORTFOLIO_STATUS,
  DELETE_EXCLUDE_PORTFOLIO_LIST_FAILURE,
} from "./types";

export const initialState: PortfoliosState = {
  portfolios: [],
  excludePortfolioStatus: null,
};

export default function (
  state = initialState,
  action: PortfoliosActionTypes | SearchActionTypes
): PortfoliosState {
  switch (action.type) {
    case FETCH_PORTFOLIOS_SUCCESS: {
      console.log("action.payload_FETCH_PORTFOLIOS_SUCCESS", action.payload);
      const newPortfolios = (action.payload as FetchPortfoliosResponse)
        .portfolios;

      return {
        ...state,
        portfolios: newPortfolios,
        //   currentPortfolios
        //     .concat(
        //       newPortfolios.filter(
        //         (p: Portfolio) => !currentPortfolioIds.has(p.id)
        //       )
        //     )
        //     .sort(
        //       (a, b) =>
        //         new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        //     ),
      };
    }
    case DELETE_EXCLUDE_PORTFOLIO_LIST_REQUEST: {
      return {
        ...state,
        excludePortfolioStatus: action.type,
      };
    }
    case DELETE_EXCLUDE_PORTFOLIO_LIST_SUCCESS: {
      return {
        ...state,
        excludePortfolioStatus: action.type,
      };
    }
    case DELETE_EXCLUDE_PORTFOLIO_LIST_FAILURE: {
      return {
        ...state,
        excludePortfolioStatus: action.type,
      };
    }
    case RESET_EXCULDE_PORTFOLIO_STATUS: {
      return {
        ...state,
        excludePortfolioStatus: null,
      };
    }
    case RESET_SEARCH: {
      return {
        ...state,
        portfolios: [],
      };
    }
    default:
      return state;
  }
}
